module.exports = __webpack_public_path__ + "static/assets/2b0b532fda25919c2ea7ff2129ae9271.png";